import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Phone, Mail } from 'lucide-react';
import { useCms } from '../context/CmsContext';

const Footer = () => {
  const { t } = useCms();
  const phoneDisplay = t('contact.phone', '+31 6 1234 5678');
  const phoneTel = phoneDisplay.replace(/\s/g, '');
  const email = t('contact.email', 'info@cocktailmannetje.nl');
  const instagram = t('contact.instagram', 'https://www.instagram.com/cocktailmannetje1/');

  return (
    <footer className="bg-[#13498f] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Cocktailmannetje</h3>
            <p className="text-gray-200 mb-4">
              Professionele cocktails op locatie voor een vaste prijs. Luxe uitstraling, zomerse sfeer, onvergetelijke ervaringen.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Navigatie</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-[#FFB84D] transition-colors">Home</Link></li>
              <li><Link to="/over-ons" className="hover:text-[#FFB84D] transition-colors">Over Ons</Link></li>
              <li><Link to="/hoe-werkt-het" className="hover:text-[#FFB84D] transition-colors">Hoe werkt het?</Link></li>
              <li><Link to="/menu" className="hover:text-[#FFB84D] transition-colors">Cocktailmenu</Link></li>
              <li><Link to="/contact" className="hover:text-[#FFB84D] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone size={18} />
                <a href={`tel:${phoneTel}`} className="hover:text-[#FFB84D] transition-colors">{phoneDisplay}</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} />
                <a href={`mailto:${email}`} className="hover:text-[#FFB84D] transition-colors">{email}</a>
              </li>
              <li className="flex items-center gap-3 mt-4">
                <a href={instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[#FFB84D] transition-colors">
                  <Instagram size={24} />
                </a>
                <a href="https://tiktok.com/@cocktailmannetje1" target="_blank" rel="noopener noreferrer" className="hover:text-[#FFB84D] transition-colors">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-2 text-gray-200">
          <p>&copy; 2025 Cocktailmannetje. Alle rechten voorbehouden.</p>
          <Link to="/admin/login" rel="nofollow" className="text-xs text-gray-300 hover:text-white" data-testid="footer-admin-link">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
